export enum AriaMenuStatus {
    Open,
    Closed,
    ClosedByKeyboardEvent
}
